import debug from 'debug';

import { getOrdersDetails } from '@services/order';
import { GETTING_ORDERS, GOT_ORDERS, OrdersActionsType } from '@store/types';

export const getOrders = () => {
  const log = debug('getOrders');
  return (dispatch: (action: OrdersActionsType) => void): any => {
    dispatch({ type: GETTING_ORDERS });
    getOrdersDetails()
      .then((orders) => {
        dispatch({ type: GOT_ORDERS, payload: orders });
      })
      .catch((error) => {
        log({ error });
      });
  };
};
